import { Icon, type IconProps } from './Icon';

/** Balão de conversa — abre e fecha os comentários do cartão. */
export function MessageCircleIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <path d="M7.9 20A9 9 0 1 0 4 16.1L2 22Z" />
    </Icon>
  );
}
